<icz-essl-object-detail
  [waiting]="loadingService.isLoading$(this) | async"
  [objectNameGeneratorFn]="documentNameGeneratorFn"
  [baseUrlPrefixParts]="baseUrlPrefixParts"
>
  <icz-document-detail-toolbar
    toolbar
    [spinnerDiameter]="40"
    [waiting]="loadingService.isLoading$(documentDetailService) | async"
    [runningActivity]="documentDetailService.runningActivity$ | async"
    [refActivity]="documentDetailService.refActivity$ | async"
    [refTask]="documentDetailService.refTask$ | async"
    [isRegistryOfficeTransferActivityView]="(documentDetailService.isRegistryOfficeTransferActivityView$ | async)!"
  ></icz-document-detail-toolbar>
  <router-outlet class="router-outlet-block-container"></router-outlet>
</icz-essl-object-detail>
